import { searchCommonConfig } from './common'
import { theme as brandTheme } from '@/config/brands'

/**
 * Moonpage 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: brandTheme.bgTag,
    startReadingBg: brandTheme.primaryGradient || 'linear-gradient(90deg, #8DB8FF 0%, #5E79F6 100%)',
    isLight: true,
    cardPadding: '0',
    cardBorder: 'none',
    cardBg: 'transparent',
  },
}
